import { lazy } from "react";
import { AuthenticatedHomeRedirect, AuthenticatedRedirect } from "./AuthRedirect";

// Authentication
const Login = lazy(() => import("../pages/Authentication/Login"));
const Logout = lazy(() => import("../pages/Authentication/Logout"));

// Admin pages
const AdminDashboard = lazy(() => import("../pages/Admin/Dashboard"));
const AdminProperties = lazy(() => import("../pages/Admin/Properties"));
const AdminVendors = lazy(() => import("../pages/Admin/Vendors"));
const AdminBookings = lazy(() => import("../pages/Admin/Bookings"));

const authProtectedRoutes = [
  { path: "/dashboard", component: <AdminDashboard /> },
  { path: "/properties", component: <AdminProperties /> },
  { path: "/vendors", component: <AdminVendors /> },
  { path: "/bookings", component: <AdminBookings /> },

  { path: "/index", component: <AuthenticatedHomeRedirect /> },
  { path: "/", exact: true, component: <AuthenticatedHomeRedirect /> },
  { path: "*", component: <AuthenticatedHomeRedirect /> },
];

const publicRoutes = [
  { path: "/logout", component: <Logout /> },
  { path: "/login", component: <AuthenticatedRedirect><Login /></AuthenticatedRedirect> },
];

export { authProtectedRoutes, publicRoutes };
